import { useQuery } from 'react-query';

import { getRecords } from '@utils/backend-api/universal';

export const NEWSLETTERS_KEY = 'NEWSLETTERS';

export default function useNewsletters() {
  const { data, isLoading } = useQuery(
    NEWSLETTERS_KEY,
    async () =>
      await getRecords({
        model: 'Newsletter',
        attributes: ['description', 'id', 'landing_page_description', 'frequency', 'name'],
        helpers: ['card_image_url_imgix'],
        identifiers: { active: true, tiBundled: true, thirdParty: false },
        relations: {
          author: { attributes: ['name'] },
        },
      })
  );

  return { newsletters: data?.result, isLoadingNewsletters: isLoading };
}
